import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../axiosInstance";
import { handleApiError } from "../handleApiError";

const API_URL = "/contactUs";

// ✅ SEND MESSAGE (PUBLIC)
export const sendContactMessage = createAsyncThunk(
  "contact/send",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API_URL, data);

      toast.success("Message Sent Successfully", {
        autoClose: 3000,
      });

      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to Send Message";

      toast.error(message, { autoClose: 3000 });

      return rejectWithValue({ message });
    }
  },
);

// ✅ GET ALL (ADMIN)
export const getContactMessages = createAsyncThunk(
  "contact/getAll",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams();

      if (params.page) query.append("page", params.page);
      if (params.limit) query.append("limit", params.limit);

      const response = await axiosInstance.get(
        `${API_URL}?${query.toString()}`,
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);

// ✅ GET ONE (ADMIN)
export const getContactMessageById = createAsyncThunk(
  "contact/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message },
      );
    }
  },
);

// ✅ DELETE (ADMIN)
export const deleteContactMessage = createAsyncThunk(
  "contact/delete",
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${API_URL}/${id}`);

      toast.success("تم حذف الرسائل بنجاح", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue({ message });
    }
  },
);
